const Layout = r =>
  require.ensure([], () => r(require('@/layout/layout1.vue')), 'base')

// 权限管理
const resource = r =>
  require.ensure(
    [],
    () => r(require('@/modules//zkCdpPage/privilege/resource.vue')),
    'privilege'
  )
const role = r =>
  require.ensure(
    [],
    () => r(require('@/modules//zkCdpPage/privilege/role.vue')),
    'privilege'
  )
const adminAccount = r =>
  require.ensure(
    [],
    () =>
      r(require('@/modules/enterpriseAdmin/accountManager/adminAccount.vue')),
    'enterpriseAdmin'
  )
const integratorsManager = r =>
  require.ensure(
    [],
    () => r(require('@/modules/comComponent/integratorsManager.vue')),
    'enterpriseAdmin'
  )
const integratedAccount = r =>
  require.ensure(
    [],
    () =>
      r(
        require('@/modules/enterpriseAdmin/accountManager/integratedAccount.vue')
      ),
    'enterpriseAdmin'
  )

const user = r =>
  require.ensure(
    [],
    () => r(require('@/modules/zkCdpPage/personal/user.vue')),
    'personal'
  )

const privilegeRouter = {
  path: '/privilege',
  name: 'privilege',
  component: Layout,
  meta: {
    id: 'sys-menu-b',
    auth: true
  },
  redirect: '/privilege/resource',
  children: [
    {
      path: 'resource',
      name: 'resource',
      component: resource,
      meta: {
        id: 'sys-menu-b-1',
        auth: true
      }
    },
    {
      path: '/adminAccount',
      name: 'adminAccount',
      component: adminAccount,
      meta: {
        id: 'ba91e0f5c8ee4e72a5ba139a013c33bd',
        auth: true
      }
    },
    {
      path: '/user',
      name: 'user',
      component: user,
      meta: {
        id: 'sys-menu-a-1',
        auth: true
      }
    },

    {
      path: 'role',
      name: 'role',
      component: role,
      meta: {
        id: 'sys-menu-b-2',
        auth: true
      }
    },
    {
      path: '/privilege/integratorsManager',
      name: 'integrationAccount',
      component: integratorsManager,
      meta: {
        id: '4cac0d8e3eb34d64ad9213aeb5a2bfeb',
        auth: true
      }
    },
    {
      path: 'integrationAccount',
      name: 'integrationAccount',
      component: integratedAccount,
      meta: {
        id: '828478ec21734d7396addbd5a7a7b49c',
        auth: true
      }
    }
  ]
}
export default privilegeRouter



// WEBPACK FOOTER //
// ./src/pages/index/router/modules/privilege.js